// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"CustomSearchBox-module--search-input-wrapper--17363","searchInputIcon":"CustomSearchBox-module--search-input-icon--06ef9"};